import {
  EfsMelcoEfsModelsMappingListItem,
  ProductionFulfillmentApi,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export type DataMappingAttribute = "_text" | "_color" | "_font" | "_display";

export const useDataMappings = (inputFormatId: string) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<EfsMelcoEfsModelsMappingListItem>();

  const query = useAPIQuery(
    ProductionFulfillmentApi,
    [
      "dataMappings",
      inputFormatId,
      currentPage,
      pageSize,
      filters,
      sortBy(),
      searchQuery,
    ],
    async (api) => {
      const response = await api.productionFulfillmentMappingsGetList({
        formatId: inputFormatId,
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
        global: true,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
